import { CheckIcon, CopyIcon } from 'lucide-react'

import useCopy from '@hooks/use-copy'

import { Button } from '@shadcn/button'

import { cn } from '@/lib/utils'

interface CopyButtonProps {
  text: string
  label: string
  className?: string
}

const CopyButton = ({ text, label, className }: CopyButtonProps) => {
  const { copied, copy } = useCopy(text)

  return (
    <Button
      onClick={copy}
      variant="ghostGray"
      size="ghost"
      name={`copy-${label}`}
      className="relative size-4"
    >
      <CopyIcon
        color="var(--fg-secondary-700)"
        className={cn(
          'absolute size-4 transition-all',
          {
            'scale-0 -rotate-90': copied,
            'scale-100 rotate-0': !copied,
          },
          className,
        )}
      />
      <CheckIcon
        color="var(--success-700)"
        className={cn(
          'absolute size-4 transition-all',
          {
            'scale-0 -rotate-90': !copied,
            'scale-100 rotate-0': copied,
          },
          className,
        )}
      />
    </Button>
  )
}

export default CopyButton
